import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'amFromUtc'})
export class FromUtcPipe implements PipeTransform {
  public transform(value: any, ...args: string[]): any {
    if (!value) {
      return '';
    }
    return moment.utc(value);
  }
}
